import Icon from '../components/Icon.vue'

Icon.register({
  'hand-holding-usd': {
    width: 544,
    height: 512,
    paths: [
      {
        d: 'M257.6 144.3c-22.2-6.4-40-24.7-42.9-47.7-4-32 19-59.4 49.3-63v-17.6c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v17.7c11.5 1.4 22.3 5.2 31.8 11.5 6.2 4.1 6.8 13.1 1.5 18.4l-17.5 17.5c-3.7 3.7-9.3 4.2-14.1 2-3.2-1.4-6.7-2.2-10.3-2.2h-32.8c-4.6 0-8.4 3.8-8.4 8.4 0 3.7 2.5 7.1 6.1 8.1l50 14.3c22.2 6.4 40 24.7 42.9 47.7 4 32-19 59.4-49.3 63v17.6c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-17.7c-11.5-1.4-22.3-5.2-31.8-11.5-6.2-4.1-6.8-13.1-1.5-18.4l17.5-17.5c3.7-3.7 9.3-4.2 14.1-2 3.2 1.4 6.7 2.2 10.3 2.2h32.8c4.6 0 8.4-3.8 8.4-8.4 0-3.7-2.5-7.1-6.1-8.1zM533.9 328.1c14.2 13.6 13.1 36.8-1.3 48.9l-142.8 121c-10.8 9.1-24.1 14-37.8 14h-336.9c-8.3 0-15.1-7.2-15.1-16v-96c0-8.8 6.8-16 15.1-16h52.4l43.9-37.7c19.7-17 44.4-26.3 69.9-26.3h151.1c18.3 0 32.9 17.4 29.8 37.4-2.4 15.7-16.3 26.6-31.4 26.6h-73.9c-8.3 0-15.1 7.2-15.1 16s6.8 16 15.1 16h111.7c13.8 0 27.1-4.9 37.8-14l87.2-73.9c11.8-10 29.1-10.7 40.3 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-holding-usd.js
// module id = 1425
// module chunks = 0